// Star WebPRNT bridge — prints kitchen tickets to a LAN Star printer
// (e.g. TSP100 Ethernet) when the page is opened inside the Star WebPRNT
// Browser app on the counter device. Falls back to the browser print
// dialog when no printer is configured or the printer can't be reached.

let loadingPromise = null;

function loadScripts() {
  if (window.StarWebPrintBuilder && window.StarWebPrintTrader) return Promise.resolve();
  if (loadingPromise) return loadingPromise;
  loadingPromise = Promise.all(
    ["/webprnt/StarWebPrintBuilder.js", "/webprnt/StarWebPrintTrader.js"].map(
      (src) =>
        new Promise((resolve, reject) => {
          const s = document.createElement("script");
          s.src = src;
          s.onload = resolve;
          s.onerror = () => reject(new Error(`Failed to load ${src}`));
          document.head.appendChild(s);
        })
    )
  );
  return loadingPromise;
}

function normalizeUrl(raw) {
  let u = (raw || "").trim();
  if (!u) return "";
  if (!/^https?:\/\//i.test(u)) u = `http://${u}`;
  if (!/StarWebPRNT/i.test(u)) u = `${u.replace(/\/+$/, "")}/StarWebPRNT/SendMessage`;
  return u;
}

export function hasPrinter(raw) {
  return !!normalizeUrl(raw);
}

const money = (n) => `$${Number(n).toFixed(2).replace(/\.00$/, "")}`;
const RULE = "--------------------------------\n";

function buildReceipt(builder, o) {
  let r = "";
  r += builder.createInitializationElement();
  r += builder.createAlignmentElement({ position: "center" });
  r += builder.createTextElement({ emphasis: true, width: 2, height: 2, data: "HARBOUR HAZE\n" });
  r += builder.createTextElement({ emphasis: true, data: "TAKEAWAY\n\n" });
  r += builder.createTextElement({ emphasis: true, width: 3, height: 3, data: `#${o.order_number}\n` });
  r += builder.createTextElement({ data: `${new Date(o.created_at).toLocaleString()}\n` });
  r += builder.createAlignmentElement({ position: "left" });
  r += builder.createTextElement({ data: RULE });
  r += builder.createTextElement({ emphasis: true, width: 2, height: 2, data: `${o.fulfilment === "delivery" ? "DELIVERY" : "PICK UP"}\n` });
  r += builder.createTextElement({ emphasis: true, data: `Wanted: ${o.requested_time || "ASAP"}\n` });
  r += builder.createTextElement({ data: RULE });
  (o.cart || []).forEach((c) => {
    r += builder.createTextElement({ emphasis: true, data: `${c.qty} x ${c.name}\n` });
  });
  r += builder.createTextElement({ data: RULE });
  r += builder.createTextElement({ data: `Subtotal: ${money(o.subtotal)}\n` });
  if (o.delivery_fee) r += builder.createTextElement({ data: `Delivery: ${money(o.delivery_fee)}\n` });
  r += builder.createTextElement({ emphasis: true, data: `TOTAL: ${money(o.total)}  ${o.payment_status === "paid" ? "PAID ONLINE" : "PAY AT TILL"}\n` });
  r += builder.createTextElement({ data: RULE });
  r += builder.createTextElement({ data: `${o.name}  ${o.phone}\n` });
  if (o.address) r += builder.createTextElement({ data: `${o.address}\n` });
  if (o.notes) r += builder.createTextElement({ emphasis: true, data: `NOTES: ${o.notes}\n` });
  r += builder.createFeedElement({ line: 1 });
  r += builder.createCutPaperElement({ feed: true, type: "partial" });
  return r;
}

export async function sendToStarPrinter(rawUrl, order) {
  const url = normalizeUrl(rawUrl);
  if (!url) throw new Error("No printer configured");
  await loadScripts();
  const builder = new window.StarWebPrintBuilder();
  const request = buildReceipt(builder, order);
  return new Promise((resolve, reject) => {
    const trader = new window.StarWebPrintTrader({ url });
    trader.onReceive = (res) => {
      if (res.traderSuccess === "true") resolve(res);
      else reject(new Error("Printer reported an error (check paper/cover)"));
    };
    trader.onError = (res) => reject(new Error(`Printer unreachable (${res.status})`));
    trader.onTimeout = () => reject(new Error("Printer timed out"));
    try {
      trader.sendMessage({ request });
    } catch (e) {
      reject(e);
    }
  });
}
